import { Row, Col } from 'antd';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { ButtonSizes } from '~src/shared/buttons/basicButtons/BaseButton.sc';
import MobileLogoutButton from '~src/shared/buttons/MobileLogoutButton';
import { Web, Mobile, PageContentContainer } from '~src/styles/containers.sc';
import { routes } from '~src/routingConfig';
import SvgPicture from '~src/shared/SvgPicture';

import { MsgButton } from './NoSurvey.sc';
import {
  SuccessMessage,
  LoopPicture,
  SuccessTitle,
  SuccessSubTitle,
  LogOutContainer,
  RedirectContentWrapper,
} from './cards/redirectCard.sc';

interface Props {
  moreQuestions: boolean;
  isAdmin: boolean;
  /*redirect: boolean;*/
  showRedirect: boolean;
}

const RedirectContent: FC<Props> = ({ moreQuestions, isAdmin,/* redirect, */showRedirect }) => {
  const isAdminString = `${isAdmin ? '.admin' : ''}`;
  const moreQuestionsString = moreQuestions ? '.more_questions' : '';

  const {t} = useTranslation();

  return (
    <RedirectContentWrapper $moreQuestions={moreQuestions} /*redirect={redirect}*/>
      <PageContentContainer>
        <Row>
          <Col
            xs={{ span: 24, offset: 0 }}
            lg={{ span: moreQuestions ? 14 : 8, offset: moreQuestions ? 5 : 8 }}
          >
            <SuccessMessage $showRedirect={showRedirect}>
              <LoopPicture $moreQuestions={moreQuestions}>
                <SvgPicture name={moreQuestions ? 'loopPicture' : 'loopCongrats'} />
              </LoopPicture>
              <SuccessTitle
                data-translation={`x.questions.finishedcard.header${moreQuestionsString}${isAdminString}`}
              >
                {t(`x.questions.finishedcard.header${moreQuestionsString}${isAdminString}`)}
              </SuccessTitle>
              <SuccessSubTitle
                data-translation={`x.questions.finishedcard.header.subtitle${moreQuestionsString}${isAdminString}`}
                $moreQuestions={moreQuestions}
              >
                <Web>
                  {t(`x.questions.finishedcard.header.subtitle${moreQuestionsString}${isAdminString}`)}
                </Web>
                <Mobile>{t(`x.questions.finishedcard.header.subtitle${moreQuestionsString}`)}</Mobile>
              </SuccessSubTitle>
              {!moreQuestions && (
                <Link to={routes.sessionUser.home}>
                  <MsgButton
                    $buttonColor="white"
                    $buttonSize={ButtonSizes.Wide}
                    data-translation={'x.questions.finishedcard.button.home_hub'}
                  >
                    {t('x.questions.finishedcard.button.home_hub')}
                  </MsgButton>
                </Link>
              )}
            </SuccessMessage>
          </Col>
        </Row>
      </PageContentContainer>
      <LogOutContainer $moreQuestions={moreQuestions}>
        <MobileLogoutButton t={t} />
      </LogOutContainer>
    </RedirectContentWrapper>
  );
};

export default RedirectContent;
